import { render, staticRenderFns } from "./Performance.vue?vue&type=template&id=c8f40ccc&scoped=true"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f40ccc",
  null
  
)

export default component.exports